import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

import CustomerList from './CustomerList';
import CustomerCreate from './CustomerCreate';
import CustomerEdit from './CustomerEdit';
import CustomerShow from './CustomerShow';


const customers = {
	list: CustomerList,
	edit: CustomerEdit,
	create: CustomerCreate,
	show: CustomerShow,
	icon: AssignmentIndIcon
};

export default customers;
